import React from 'react';
import { useIsMounted } from 'usehooks-ts';
import { populateEmpty } from '../../lib/orderbookHelpers';
import { BidAsk } from '../../types/orderbook';
import { OrderbookRow } from './OrderbookRow';

export type OrderbookColumnOrder = 'price' | 'size' | 'total';

interface OrderbookRowsProps {
  type: 'bid' | 'ask';
  reversed?: boolean;
  rows: BidAsk[];
  rowCount: number;
  priceDecimals: number;
  accountPrices: Set<bigint>;
  onRowClick: (price: bigint, amount: bigint) => void;
  formatValue: (num: bigint | undefined, price: bigint | undefined) => string;
  getWidthAndDepth: (
    price: bigint | undefined,
    type: 'bid' | 'ask'
  ) => {
    depth: bigint | undefined;
    width: string;
  };
  showTotal?: boolean;
  columnOrder?: OrderbookColumnOrder[];
}

export const OrderbookRows: React.FC<OrderbookRowsProps> = ({
  type,
  reversed = false,
  rows,
  rowCount,
  priceDecimals,
  accountPrices,
  onRowClick,
  formatValue,
  getWidthAndDepth,
  showTotal = true,
  columnOrder = ['price', 'size', 'total'],
}) => {
  const isMounted = useIsMounted();
  return populateEmpty(rows, type, rowCount).map(([price, quantity], i) => {
    const { depth, width } = getWidthAndDepth(price, type);

    return (
      <OrderbookRow
        price={price}
        quantity={quantity}
        depth={depth}
        width={width}
        type={type}
        reversed={reversed}
        priceDecimals={priceDecimals}
        hasOpenOrder={price ? accountPrices.has(price) : false}
        onRowClick={onRowClick}
        formatValue={formatValue}
        key={price?.toString() ?? `empty-${type}-${i}`}
        orderbookMounted={isMounted()}
        showTotal={showTotal}
        columnOrder={columnOrder}
      />
    );
  });
};
